import React, { useEffect, useRef, useState } from "react";
import {
  getSettlementReport,
  getTransactionSummary,
  orderSearchFilter,
} from "../../API  Functions/Eorders";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ShimmerLoader from "../../loading";
import LoadingSpinner from "../Loading";
import Third from "../Orders/Third";
import FilterSelectBox from "../CustomWidgets/EOrderFilter";
import SelectBox from "../CustomWidgets/SelectBox";
import { SetHeading } from "../../context/NavbarContext";
import { Empty } from "antd";
import TransactionSummaryTable from "./TransactionSummaryTable";
import SettlementReportTable from "./SettlementReportTable";

const SettlementReport = () => {
  const { t, i18n } = useTranslation();
  const [data, setdata] = useState([{ id: "11" }]);

  const [headingWidth, setHeadingWidth] = useState(0);
  const activeHeadingRef = useRef(null);
  const [componentData, setComponentData] = useState([]);
  const [heading_number, setheading_number] = useState(0);
  const [searched, setsearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storecount, setstorecount] = useState([]);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );
  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const now = new Date();
  const currentYear = now.getFullYear();
  const filterOptionsYears = Array.from({ length: 11 }, (_, i) => {
    const year = currentYear - 10 + i;
    return { label: year.toString(), value: year.toString() };
  });
  const [selectedMonth, setSelectedMonth] = useState(
    months[now.getMonth() - 1]
  );
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const filterOptions = [
    { label: t("January"), value: "January" },
    { label: t("February"), value: "February" },
    { label: t("March"), value: "March" },
    { label: t("April"), value: "April" },
    { label: t("May"), value: "May" },
    { label: t("June"), value: "June" },
    { label: t("July"), value: "July" },
    { label: t("August"), value: "August" },
    { label: t("September"), value: "September" },
    { label: t("October"), value: "October" },
    { label: t("November"), value: "November" },
    { label: t("December"), value: "December" },
  ];
  useEffect(() => {
    getSettlementReportData(currentYear, months[now.getMonth() - 1]);
  }, []);
  const getSettlementReportData = async (
    year,
    month,
    limit = 10,
    offset = 0
  ) => {
    console.log(month, year);
    setLoading(true);
    try {
      const response = await getSettlementReport(
        store_id,
        `${month}-${year}`,
        limit,
        offset
      );
      // console.log("daatatatatdta",response?.status_code);
      if (response?.status_code === 200) {
        // console.log("daatatatatdta",response?.data);

        setComponentData(response?.data);
      } else {
        setComponentData([]);
        // console.warn("Unexpected status_code:", response?.status_code); // Debug
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      setComponentData([]);
    } finally {
      setLoading(false);
    }
  };
  console.log("setComponentData", componentData);

  const formatSessionState = (state) => {
    if (!state) return "";

    return state
      .split("_") // Split by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words with a space
  };
  return (
    <>
      {loading && <LoadingSpinner />}
      <SetHeading value="Payment Settlement Report" />
      <div className="mt-4 flex flex-row ">
        <SelectBox
          componentWidth={"w-auto flex flex-col mt-2 border-red ms-6 me-2"}
          style={{ width: 140 }}
          width={140}
          defaultValue={months[now.getMonth() - 1]}
          placeholder={t("Select Month")}
          name="filter"
          onChange={(value) => {
            // console.log("month==>",value?.target);
            setSelectedMonth(value?.target?.value);
            getSettlementReportData(selectedYear, value?.target?.value);
          }}
          options={filterOptions}
          value={
            filterOptions?.find((option) => option?.value === selectedMonth)
              ?.value
          }
        />
        <SelectBox
          componentWidth={"w-auto flex flex-col mt-2 border-red"}
          style={{ width: 140 }}
          defaultValue={currentYear}
          width={140}
          placeholder={t("Select Year")}
          name="filter"
          onChange={(value) => {
            // console.log("year==>",value.target);
            setSelectedYear(value?.target?.value);
            getSettlementReportData(value?.target?.value, selectedMonth);
          }}
          options={filterOptionsYears}
          value={
            filterOptions?.find((option) => option?.value === selectedYear)
              ?.value
          }
        />
      </div>
      <div className="">
        {componentData ? (
          <div className="flex flex-wrap mt-10 ms-6">
            <SettlementReportTable additionalData={componentData} />
          </div>
        ) : (
          <>
            <Empty className=" mt-40" description={t("No data available")} />
          </>
        )}
      </div>
    </>
  );
};

export default SettlementReport;
